import {createFileRoute, redirect} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/guides/')({
  beforeLoad: () => {
    throw redirect({
      to: '/',
    });
  },
});
